import type { StateCreator } from 'zustand'

interface State {
  canExplode: boolean
}

interface Actions {
  setCanExplode: (canExplode: boolean) => void
}

export type LiveRocketGameSlice = State & Actions

export const liveRocketGameStore: StateCreator<
  LiveRocketGameSlice,
  [],
  [],
  LiveRocketGameSlice
> = (set) => ({
  canExplode: false,
  setCanExplode: (canExplode) => set({ canExplode }),
})
